<template>
  <div class="km__modules__color--areacolorgrouping">
    <ul class="km__list--modules"
        v-show="visibleAreaColorObjects.length>0">
      <li class="km__list__element--modules"
          v-for="color in visibleAreaColorObjects"
          :key="color.colorCode"
          :class="{ active:currentColorCode === color.colorCode || currentColorCode.replace('_O', '') === color.colorCode}"
      >
        <div class="km__button--outline"
             :style="{'background-color': color.outlineColorvalue === null ? hexWithPoundsign(color) : hexWithPoundSignOutline(color)}"
             :class="{ border:color.outlineColorvalue === null ? colorIsNearWhite(color.colorValue) : colorIsNearWhite(color.outlineColorvalue) }"
             @click="$emit('colorpicker_clicked', color)"
        >
          <div class="km__button--patternpreview" v-if="color.hatPattern && color.outlineColorvalue === null"
               v-html="getPatternPreviewImage(color)"></div>
          <div
              v-if="!(color.outlineColorvalue === null && color.hatPattern)"
              class="km__button--color"
              :class="{border:colorIsNearItsOutline(color)}"
              :style="{ 'background-color': hexWithPoundsign(color) }"

          >
            <div class="km__button--patternpreview" v-if="color.hatPattern"
                 v-html="getPatternPreviewImage(color)"></div>
          </div>
        </div>
        <span v-if="hatSpezialname(color.colorCode)" class="km__label--text kragen">
          {{ $t(getSpezialFarbname(color.colorCode)) }}
        </span>
        <span v-else class="km__label--text">
          {{ $t("konf_farbe") }} {{ color.colorCodeNr }}
        </span>
      </li>
    </ul>

  </div>
</template>

<script lang="ts" setup>
import {ColorUtilsVue} from "@km/js/ColorUtilsVue";
import {ColorUtils} from "@k/js/colorUtils";
import {compose} from "@k/global/functionalTools";
import {useStore} from "vuex";
import {AnimationWaitingForTargetFactory, KeyFrameTargetValues} from "@km/animations/animationFactory";
import {setWatchToAnimateOnStatechange} from "@km/js/animater";

import {PatternPreviewImageHolder} from "@km/store/ColorDataGetterFromResourceStore";
import {getSpezialFarbname, hatSpezialname} from "@km/components/color/FarbAnzeigeNamen";
import {ColorViewDataWithOutlineAndPatterns} from "@km/components/color/ColorViewDataWithOutlineAndPatterns";
import {useModuleColorOpenStateStore} from "@km/store/frontendstate/useModuleColorOpenState";


const props = defineProps({
  visibleAreaColorObjects: Array as PropType<ColorViewDataWithOutlineAndPatterns[]>,
  currentColorCode: String
})


const store = useStore();
const animation = AnimationWaitingForTargetFactory.getUpDownAnimation(".km__modules__color--areacolorgrouping");
const openStateStore = useModuleColorOpenStateStore();
setWatchToAnimateOnStatechange(animation, new KeyFrameTargetValues(0, 100), () => openStateStore.getAreaColorGroupSelection);

function openPopup(popup) {
  store.commit("SET_OVERLAY_OPEN", popup);
}

const hexWithPoundsign = ColorUtilsVue.hexWithPoundsign;
const hexWithPoundSignOutline = (color: ColorViewDataWithOutlineAndPatterns) => ColorUtilsVue.hexWithPoundsign(color, "outlineColorvalue");
const colorIsNearWhite = compose(ColorUtilsVue.colorHexIsNearWhite, ColorUtils.decToHex);
const colorIsNearItsOutline = (color: ColorViewDataWithOutlineAndPatterns) => color.outlineColorvalue === null ? false : ColorUtilsVue.colorsAreNearToEachOther(color.colorValue, color.outlineColorvalue);
const getPatternPreviewImage = (color: ColorViewDataWithOutlineAndPatterns) => PatternPreviewImageHolder.getPreviewImage(color.colorCodeNr).value;


</script>

<style lang="scss" scoped>
@use "../../scss/settings/config" as config;
@use "../../scss/settings/mixins.scss" as mixins;

/* ***********************************
*	MODULE COLOR
* - Color Default List
* ********************************** */

/* ***********************************
*	Color Default List
* ********************************** */
.km__button--icon {
  &.farbvorschlag {
    width: 40px;
    height: 40px;
    padding-bottom: 0;
    margin-bottom: 2px;
    background-size: 38px;
  }
}


.km__modules__color--areacolorgrouping {
  position: fixed;
  height: 80px;
  width: 100%;
  left: 0;
  bottom: config.$cta-height;
  z-index: 8;
  background: config.$color-white;
  padding: 0 10px 10px 10px;
  transform: translate(0px, 80px);
  overflow-y: hidden;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;

  .km__list--modules {
    position: relative;
    display: flex;
    flex-direction: row;
    justify-content: center;

    .km__list__element--modules {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      padding: 0 8px;

      .km__button--outline {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
      }

      .km__button--color {
        width: 30px;
        height: 30px;
        margin-bottom: 0;

        .km__button--patternpreview {
          width: 100%;
          height: 100%;
        }

      }

      &.active {
        .km__button--outline {
          &:after {
            @include mixins.color-active;
          }
        }
      }
    }
  }

  .km__label--text {
    height: 15px;
  }
}

.km__button--patternpreview {
  width: 38px;
  height: 38px;
  position: relative;
  overflow: hidden;
}

:deep(svg) {
  width: 180%;
  height: 180%;
  position: absolute;
  top: -15px;
  left: -15px;
}
</style>
